import { useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@/store/user/slice'
import {
  karteTracker,
  sendKarteEvent,
  setKarteUser,
  resetViewEventFlag,
  KarteEventData,
  KarteUserData,
} from '@/utility/karte'

/**
 * SSR時はGTMからviewイベントが送信されるためReact側では送信しない
 * SSR時の初回送信制御用フラグ
 */
let isInitialLoad = true

/**
 * KARTE関連の処理を管理するカスタムフック
 *
 * Reactコンポーネント用のKARTE統合フック。
 * 主な利点:
 * - ユーザー情報の自動同期（ログイン/ログアウト時）
 * - 共通データの自動付与が可能
 *
 * シンプルなイベント送信のみの場合は、utility/karte.ts の
 * sendKarteEvent() を直接使用しても同じ
 */
export const useKarte = () => {
  const currentUser = useSelector(selectCurrentUser)

  // ページビュートラッキング
  const trackPageView = useCallback(() => {
    if (isInitialLoad) {
      // GTMが送信するためスキップ
      isInitialLoad = false
      return
    }

    // SPA内ページ遷移時のみReactが送信
    resetViewEventFlag() // flagリセット
    karteTracker()
  }, [])

  // カスタムイベント送信
  const trackEvent = useCallback((eventName: string, eventData?: KarteEventData) => {
    sendKarteEvent(eventName, eventData)
  }, [])

  // ユーザー情報設定
  const setUser = useCallback((userData: KarteUserData) => {
    setKarteUser(userData)
  }, [])

  // ユーザーログイン時にユーザー情報を設定
  useEffect(() => {
    if (currentUser?.id) {
      setUser({
        user_id: currentUser.id,
        email: currentUser.email,
        // 必要に応じて他のユーザー情報も追加
      })
    }
  }, [currentUser, setUser])

  return {
    trackPageView,
    trackEvent,
    setUser,
  }
}
